module.exports = __webpack_public_path__ + "static/media/extra-jam-physalis-package.7046eb10.png";